import React, { useContext, useState, useRef, useEffect } from "react";
import data from "../language.json";
import languageContext from "../context/language/languageContext";
import Question from "./Question";
import Answer from "./Answer";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FaFilePdf } from "react-icons/fa";
import Recorder from "recorder-js";
import {API_URL,FAST_API_URL} from "../api"
import {
  FaArrowCircleUp,
  FaMicrophone,
  FaStop,
  FaPaperPlane,
  FaTimes,
  FaUpload,
} from "react-icons/fa";
// import { ReactMic } from "react-mic";

const Ask = () => {
  const {
    lang,
    setSessionTimeout,
    dataApi,
    setData,
    setAlert,
    setMessage,
    isRightPanel,
    setIsRightPanel,
  } = useContext(languageContext);

  const fileInputRef = useRef(null);
  const inputRef = useRef(null);
  const mainBoxRef = useRef(null);

  const [visible, setVisible] = useState(true);
  const [isRecording, setIsRecording] = useState(false);
  const [ismic, setismic] = useState(false);
  const [audioBlob, setAudioBlob] = useState(null);
  const [audioUrl, setAudioUrl] = useState("");
  const [loading, setLoading] = useState(false);

  const [interactions, setInteractions] = useState([]);
  const [session, setsession] = useState({});
  const [input, setInput] = useState("");
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]); // Store data
  const recorderRef = useRef(null);
  const audioContextRef = useRef(null);

  const navigate = useNavigate();

  const scrollToBottom = () => {
    if (mainBoxRef.current) {
      mainBoxRef.current.scrollTo({
        top: mainBoxRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  };
  const sendAudio = async (blob) => {
    if (audioUrl) {
      const formData = new FormData();
      formData.append("file", blob);
      formData.append("lang", data[lang]["name"])
      try {
        const response = await axios.post(
          `${API_URL}/voice_to_text`,
          formData,
          { headers: {  "Content-Type": "multipart/form-data"} }
        );
        const transcribedText = response.data.text;
        askQuestion(transcribedText, audioBlob);
      } catch (error) {
        setAlert(true);
        setMessage("You have been logged out. Please login again.");
      }
    }
  };
  const gettingResponse = async (text) => {
    let headersList = {
      Accept: "*/*",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    };
    let bodyContent = JSON.stringify({
      qcare: true,
      question: text,
      session: session,
      lang: data[lang]["name"],
    });
    try {
      let response = await axios.post(
        `${API_URL}/al_voice_chat_webside`,
        bodyContent,
        { headers: headersList }
      );
      if (response.data.ans !== "") {
        setInteractions((prev) => [
          ...prev,
          { type: "answer", text: response.data.ans, audio: null },
        ]);
        setData((prevData) => [
          ...prevData,
          { type: "answer", text: response.data.ans },
        ]);
        setsession(response.data.session);
      }
    } catch (error) {
      if (error?.response?.data?.detail === "Token has expired") {
        setSessionTimeout(true);
      } else {
        setAlert(true);
        setMessage("You have been logged out. Please login again.");
      }
    }
  };
  const askQuestion = async (text) => {
    console.log(text, "text")
    if (text !== "") {
      const alertKeywords = [
        "double vision",
        "severe nausea",
        "vomiting",
        "constipation",
        "diarrhea",
        "bleeding",
        "bruise marks",
        "blood in stool",
        "blood in urine",
        "breathing difficulty",
        "choking",
        "change in behaviour",
      ];
      const lowerCaseText = text.toLowerCase();
      const shouldTriggerAlert = alertKeywords.some((keyword) =>
        lowerCaseText.includes(keyword)
      );
      if (shouldTriggerAlert) {
        try {
          const token = localStorage.getItem("token");
          const patientId = localStorage.getItem("patient_id");
          if (patientId && token) {
            let response = await axios.post(
              `${API_URL}/symptom_send_alert`,
              { symptoms: text },
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                  "Content-Type": "application/json",
                },
              }
            );
            if (response.data.status === 400) {
              setMessage("You’ve already been alerted");
              setTimeout(() => setAlert(false), 10);
            }
          }
        } catch (error) {
          console.error("Failed to delete alert cache", error);
        }
      }
      setData((prevData) => [...prevData, { type: "question", text }]);
      setInteractions((prev) => [
        ...prev,
        { type: "question", text, audio: null },
      ]);
      gettingResponse(text);
      setInput("");
    }
  };
  const handleText = (e) => {
    setInput(e.target.value);
  };
  const handleFileUploadClick = () => {
    fileInputRef.current.click();
  };
  const handleImageUpload = async (e) => {
    setLoading(true);
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);
    formData.append("session", JSON.stringify(session));
    formData.append(
      "phone_number",
      localStorage.getItem("patient_phone_number")
    );
    try {
      if (file.type.startsWith("image/")) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setInteractions((prev) => [
            ...prev,
            { type: "image", src: reader.result },
          ]);
        };
        reader.readAsDataURL(file);
      } else if (file.type === "application/pdf") {
        setInteractions((prev) => [
          ...prev,
          {
            type: "pdf",
            name: file.name,
          },
        ]);
      }
      const response = await axios.post(
        `${FAST_API_URL}/api/analyze-report`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      const analysisText = response.data.analysis;

      setInteractions((prev) => [
        ...prev,
        { type: "answer", text: analysisText },
      ]);

      setData((prevData) => [
        ...prevData,
        { type: "answer", text: analysisText },
      ]);
      setsession(response.data.session_received);
    } catch (error) {
      console.error("Error uploading file:", error);
    } finally {
      setLoading(false);
    }
  };
  const convertBlobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };
  const handleSendAudioBase64 = async (blob) => {
    // console.log(audioBlob)
    // if (!audioBlob) return;

    const base64Data = await convertBlobToBase64(blob);
    // console.log("Base64:", base64Data);
    return base64Data

  };
  useEffect(() => {
    if (mainBoxRef.current) {
      mainBoxRef.current.scrollTop = mainBoxRef.current.scrollHeight;
    }
  }, [interactions, isRecording]);

  const startRecording = async () => {
    audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
    recorderRef.current = new Recorder(audioContextRef.current);

    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    await recorderRef.current.init(stream);
    recorderRef.current.start();
    setIsRecording(true);
  };

  const stopRecording = async () => {
    const { blob } = await recorderRef.current.stop();
    const url = URL.createObjectURL(blob);
    setAudioUrl(url);
    console.log(url)
    setIsRecording(false);
    // 👉 Upload the WAV file
    sendAudio(blob);
  };

  return (
    <div className="flex flex-col lg:flex-row h-screen w-full bg-gray-100">
      {/* Main Chat Section */}
      <div className="flex flex-col w-full lg:w-8/12 mx-auto p-4 bg-white shadow-lg rounded-lg h-[90vh] relative">
        <div
          className="flex-grow overflow-y-auto px-4 py-2 space-y-4 pb-24"
          ref={mainBoxRef}
        >
          {interactions.map((interaction, index) => (
            <div key={index} className="mb-4">
              {interaction.type === "question" ? (
                <Question text={interaction.text} />
              ) : interaction.type === "answer" ? (
                <Answer text={interaction.text} />
              ) : interaction.type === "image" ? (
                <div className="flex justify-center">
                  <img
                    src={interaction.src}
                    alt="Uploaded"
                    className="rounded-lg shadow-lg max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg"
                  />
                </div>
              ) : interaction.type === "pdf" ? (
                <div className="flex items-center space-x-2 text-sm text-gray-700">
                  <FaFilePdf className="text-red-500" />
                  <span>{interaction.name}</span>
                </div>
              ) : interaction.type === "audio" ? (
                <div className="flex flex-col items-center mt-3 space-y-2">
                  <span className="text-sm text-gray-600">Recorded Audio:</span>
                  <audio
                    controls
                    src={interaction.url}
                    className="w-64 rounded-lg shadow"
                  />
                </div>
              ) : null}
            </div>
          ))}

          {loading && (
            <div className="flex justify-start px-4 mb-4">
              <div className="flex items-center space-x-3 bg-gradient-to-r from-blue-100 to-blue-200 px-6 py-3 rounded-xl shadow-md animate-pulse">
                <div className="w-3 h-3 bg-blue-500 rounded-full animate-bounce"></div>
                <span className="text-sm font-medium text-blue-800">
                  Analyzing report...
                </span>
              </div>
            </div>
          )}

          {visible && (
            <div className="mx-2 mt-10 p-6 bg-gradient-to-r from-gray-200 to-gray-300 rounded-lg shadow-lg text-gray-900 text-center font-semibold text-lg border border-gray-400">
              {data[lang]["Instructions"]}
            </div>
          )}
        </div>

        {/* ===========================
                Audio Recorder 
           =========================== */}
        {/* =========================
    Recorder Section
========================== */}

        {/* Input Section */}
        <div className="bg-gray-100 absolute bottom-0 left-0 right-0 px-4 py-3 flex flex-wrap justify-center gap-2 items-center rounded-b-lg shadow-inner">
          <input
            ref={inputRef}
            placeholder="Ask your question..."
            className="flex-1 px-4 py-2 rounded-md focus:outline-none border border-gray-300 w-full sm:w-auto"
            onChange={handleText}
            onKeyDown={(e) => e.key === "Enter" && askQuestion(input)}
            value={input}
          />
          
          {input && (
            <button
              onClick={() => setInput("")}
              className="text-red-400 hover:text-red-600 transition"
            >
              <FaTimes size="1.5rem" />
            </button>
          )}
          
          <button
            onClick={() => askQuestion(input)}
            className="bg-purple-500 text-white rounded-lg px-4 py-2 hover:scale-105 transition-transform"
          >
            <FaPaperPlane size="1.2rem" />
          </button>
          
          {isRecording ? (
            <button
              onClick={() => {
                console.log("stop")
                setIsRecording(false)
                stopRecording()

                console.log(isRecording, ismic)
              }}
              className="bg-red-500 text-white rounded-lg px-4 py-2 animate-pulse hover:scale-105 transition-transform"
            >
              <FaStop size="1.5rem" />
            </button>
          ) : (
            <button
              onClick={() => {
                console.log("open")

                setIsRecording(true)
                startRecording()
              
              }
              
              }
              className="bg-green-500 text-white rounded-lg px-4 py-2 hover:scale-105 transition-transform"
            >
              <FaMicrophone size="1.5rem" />
            </button>
          )}
          
          {/* <button
            onClick={handleFileUploadClick}
            className="bg-indigo-500 text-white rounded-lg px-4 py-2 hover:scale-105 transition-transform"
          >
            <FaUpload size="1.5rem" />
          </button> */}
          
          {/* <input
            type="file"
            accept="image/*,application/pdf"
            ref={fileInputRef}
            onChange={handleImageUpload}
            style={{ display: "none" }}
          /> */}
          
          <button
            onClick={scrollToBottom}
            className="bg-blue-500 text-white rounded-lg px-4 py-2 hover:scale-105 transition-transform"
          >
            <FaArrowCircleUp size="1.5rem" />
          </button>
        </div>
      </div>

      {/* Symptom Tracker Sidebar */}
      <div className="w-full lg:w-4/12 px-4 py-4 bg-gray-50 shadow-inner border-t lg:border-l border-gray-200 overflow-y-auto h-[90vh] rounded-lg">
        <h3 className="text-xl font-semibold text-gray-700 mb-4 text-center">
          Symptom Tracker
        </h3>
        <div className="grid grid-cols-2 gap-4">
          {data[lang]["Symptoms"].map((text, index) => (
            <button
              key={index}
              className="flex items-center justify-center space-x-2 bg-white border border-gray-300 shadow-sm hover:shadow-md hover:bg-blue-50 text-gray-700 font-medium px-4 py-3 rounded-lg transition duration-200 ease-in-out"
              onClick={() => askQuestion(text)}
            >
              <span className="text-sm">{text}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Ask;

